<script lang="ts">
  import { Col, Row } from "sveltestrap";
  import data from "../../../Data/SearchResult/SearchResult.json"

</script>
<Col xl="6" class="xl-100 box-col-12">
    <Row class="search-vid-block">
        {#each data.videorightdata as searchItem}
            <Col xl="12" class="xl-50 box-col-6">
                <div class="embed-responsive embed-responsive-21by9 {searchItem.class}">
                <!-- svelte-ignore a11y-missing-attribute -->
                <iframe class="w-100" height="315" src={searchItem.src} allowfullscreen></iframe>
                </div>
            </Col>
        {/each}
    </Row>
</Col>